import { FC, memo, ReactElement, SyntheticEvent, useCallback } from 'react'
import { useNavigate } from '@tanstack/react-router'
import IconDots from 'assets/dots-icon.svg?react'
import { ChildItemsProxyClick } from 'components/ChildItemsProxyClick'
import { Dropdown } from 'components/Dropdown'
import { MenuItem } from 'components/MenuItem'
import { TOrderAccess } from 'modules/order/types'
import { ButtonIcon } from 'shared/components/ButtonIcon'

import { orderCopyRoute } from '../routes'

interface OrderActionProps {
  id: string
  access?: TOrderAccess
  className?: string
  iconClassName?: string
  onCancel?: (e: SyntheticEvent) => void
  trigger?: ReactElement
}

export const OrderAction: FC<OrderActionProps> = (props) => {
  const navigate = useNavigate()
  const { className, iconClassName, id, access, onCancel, trigger } = props

  const handleCopy = useCallback(
    (e: SyntheticEvent) => {
      e.stopPropagation()
      navigate({ to: orderCopyRoute.to, params: { id } })
    },
    [id, navigate]
  )

  return (
    <Dropdown
      className={className}
      placement="bottom-end"
      triggerEl={
        trigger || (
          <ButtonIcon className={iconClassName} containerSize="sm" icon={IconDots} size="sm" title="Действия" />
        )
      }
    >
      {({ onClose: handleClosePopover }) => (
        <ChildItemsProxyClick onClick={handleClosePopover}>
          {access?.copy && (
            <MenuItem className="text-body-md" onClick={handleCopy}>
              Копировать заявку
            </MenuItem>
          )}
          {access?.cancel && <MenuItem onClick={onCancel}>Отменить заявку</MenuItem>}
        </ChildItemsProxyClick>
      )}
    </Dropdown>
  )
}

export default memo(OrderAction)
